import React from 'react';
import { PageHero } from '../components/PageHero';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { FileText, Download } from 'lucide-react';
export function CataloguesPage() {
  const catalogues = ['Defence & Tactical Equipment', 'Police & Public Order', 'Medical & Emergency Response', 'Custodial & Restraint'];
  return <>
      <PageHero label="Manufacturing" title="Our Catalogues" subtitle="Download our sector-specific product catalogues for detailed specifications and ordering information." data-id="element-407" />
      <Breadcrumbs items={[{
      label: 'Manufacturing',
      to: '/manufacturing'
    }, {
      label: 'Our Catalogues'
    }]} data-id="element-408" />

      <section className="bg-white py-24" data-id="element-409">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-410">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-411">
            {catalogues.map(cat => <div key={cat} className="bg-slate-50 border border-steel-200 p-8 rounded-sm flex items-center justify-between group hover:border-cg-orange-600 transition-colors" data-id="element-412">
                <div className="flex items-center gap-4" data-id="element-413">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center text-cg-orange-600 shadow-sm" data-id="element-414">
                    <FileText className="w-6 h-6" data-id="element-415" />
                  </div>
                  <h3 className="font-bold text-navy-900 text-lg" data-id="element-416">{cat}</h3>
                </div>
                <button className="text-sm font-bold text-navy-900 uppercase tracking-wider flex items-center gap-2 group-hover:text-cg-orange-600 transition-colors" data-id="element-417">
                  Request <Download className="w-4 h-4" data-id="element-418" />
                </button>
              </div>)}
          </div>
        </div>
      </section>
    </>;
}